import React, {useContext, useEffect, useState} from "react";
import NotFound from "../../assets/step2.jpg";
import {OrderContext} from "../../context/OrderContext";
import {APIGetOrderTenderBidsByOrderId} from "../../api/orders/OrdersTender";
import {ParserDateTime} from "../../helper/dateFormatHandler";
import ContractTenderModal from "../dialogs/contractTenderModal";
import { UserContext } from "../../context/UserContext";
import {IoIosArrowDown, IoIosArrowForward} from "react-icons/io";
import {FileContext} from "#src/context/FileContext";
import OrderUploadBidHandler from "#src/components/orderElements/files/orderUploadCustomFolderHandler";

export default function OrderInTender() {

    const [list,setList] = useState([]);
    const [isOpen, setIsOpen] = useState(null);
    const {order, setOpenContractTender  } = useContext(OrderContext);
    const [currentTender,setCurrentTender] = useState(null);
    const {user} = useContext(UserContext);

    const toggleAccordion = (id) => {
        setIsOpen(id);
    };


    const getDatesField = (text) => {

        if(typeof text === "undefined" || text === "-") {return;}

        text = new Date(Number(text));
        text = text?.toLocaleString("de-DE", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit"
        })


        return text+" Uhr";
    };

    useEffect(() => {
        const getTender = async () => {
            const tenderBidList = await APIGetOrderTenderBidsByOrderId({orderId: order?.id, tenderId: 'getTenderId', companyId: user.companyId});
            setList(tenderBidList);
        }
        getTender();
    }, [order?.id, user.companyId]);





    return (
        <div>
            {(list?.length > 0) ? (
                <div className={"border bg-white mb-6 border-gray-400 rounded-lg"}>

                    <div className="lg:px-6 px-4 py-4 sm:px-0 ">
                        <h3 className="text-lg  font-semibold text-gray-900">Angebote</h3>
                    </div>

                    <div className={""}>

                        {list?.map((element, key) => {
                            return (
                                <div className={"border-t items-center  border-gray-400 lg:px-6 px-4 py-4"} key={key}>
                                    <div className={"flex justify-between items-center "}>
                                        <div className={"flex items-center "}>
                                            <div className=" text-sm font-semibold text-gray-900 accordion-header cursor-pointer" onClick={() => {(isOpen !== element?.id) ? toggleAccordion(element?.id) : toggleAccordion(null)}}>
                                                {(isOpen === element?.id ) ? (
                                                    <span><IoIosArrowDown  className={"mr-2 h-4 w-4 cursor-pointer"} /></span>
                                                ):(
                                                    <span><IoIosArrowForward  className={"mr-2 h-4 w-4 cursor-pointer"} /></span>
                                                )}
                                            </div>

                                            <h4 className="flex text-sm font-bold text-gray-900">
                                                {element?.companyname}
                                            </h4>
                                        </div>
                                        <span className={"text-sm items-end shrink-1 "}>{element?.bid} € (Netto)</span>

                                        <button onClick={() => { setCurrentTender(element); setOpenContractTender(true);  }}  type="button"  className="ml-3 inline-flex items-center rounded-md ring-2 ring-indigo-700 px-3 py-2 text-xs font-semibold text-indigo-700 shadow-sm hover:bg-indigo-500 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                            Beauftragen
                                        </button>
                                    </div>
                                    <div className="accordion  ">
                                        {(isOpen === element?.id) && (
                                            <div className="accordion-content lg:px-6 px-4 p-2 ">
                                                <p className={"text-sm text-gray-600/60 mt-4"}>
                                                    Anbei finden Sie alle weiteren Angaben und Unterlagen, die mit dem Angebot geliefert wurden.
                                                </p>
                                                <div key={element?.id}>
                                                    <div className="px-4  mt-6 pt-6  border-t border-gray-300 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                        <dt className="text-sm/6 font-medium text-gray-900 ">Erstellt am</dt>
                                                        <dd className="mt-1 text-sm/6 sm:col-span-2 text-gray-600/60 sm:mt-0"> {getDatesField(element?.createdAt)}</dd>
                                                    </div>
                                                    <div className="px-4  mt-6 pt-6  border-t border-gray-300 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                                        <dt className="text-sm/6 font-medium text-gray-900 ">Unterlagen zum Angebot</dt>
                                                        <dd className="mt-1 text-sm/6 sm:col-span-2 sm:mt-0">
                                                            <div className='truncate text-gray-600/60 min-h-[100px]  -mt-6'>
                                                                <FileContext.Provider className={"wrapper"} value={{order}}>
                                                                    <OrderUploadBidHandler data={[{
                                                                        name: null,
                                                                        fileType: "GML",
                                                                        path:order?.createdByCompany+"/orders/"+element?.ordersId.replace(/-/g, "/")+"/bidDocuments/"+element?.createdByCompany,
                                                                        orderEdit: false,
                                                                        orderStage: order.stage,
                                                                        isOrder:true,
                                                                        orderId:order?.id,
                                                                        orderCreator:order?.createdByCompany,
                                                                        reviewVersion:element?.creationDate,
                                                                    }]}/>
                                                                </FileContext.Provider>
                                                            </div>
                                                        </dd>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            ) : (
                <div className={"items-center flex text-center"}>
                    <div className={" m-auto w-4/12 flex text-center"}>
                        <img src={NotFound} alt="Not Found"></img>
                    </div>
                    <div className={"text-gray-600 w-8/12 m-4"}>
                        <b>Kein Gebot vorhanden</b>
                        <p>
                            Wir warten aktuell auf erstes Angebot. Sobald ein Angebot vorliegt, informieren wir Sie.
                        </p>
                    </div>
                </div>
            )}

            <ContractTenderModal data={currentTender} />
        </div>
    );




/*

        <div className={"border border-gray-500 rounded-lg divide-y divide-gray-300 overflow-hidden text-left mb-2 sm:mb-4 md:mb-8"}>
            <div className={'lg:p-6 md:p-2 p-2'}>
                <div className="px-4 sm:px-0 mb-4">
                    <h3 className="text-base/7 font-semibold text-gray-900">Aktuelle Gebote</h3>
                </div>
                <div>
                    {(list?.length > 0) ? (
                        <table className="min-w-full divide-y divide-gray-300">
                            <div className={"grid grid-cols-4"}>
                                <div

                                    className="text-sm truncate font-semibold leading-6 text-gray-900"
                                >
                                    Erstellt am
                                </div>
                                <div
                                    className="text-sm truncate font-semibold leading-6 text-gray-900"
                                >
                                    Bewerber
                                </div>
                                <div
                                    className="text-sm truncate font-semibold leading-6 text-gray-900"
                                >
                                    Gebot
                                </div>
                                <div
                                    className="text-sm truncate font-semibold leading-6 text-gray-900"
                                >

                                </div>
                            </div>

                            <div className="divide-y  divide-gray-200 bg-white">
                                {list?.map((element) => (
                                    <div className={"grid grid-cols-4"} key={element?.id}>
                                        <div className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-600 sm:pl-0">{ParserDateTime(element?.createdAt)}</div>
                                        <div className="whitespace-nowrap py-4 pl-4 pr-3 text-sm text-gray-600 sm:pl-0">{element?.companyname}</div>
                                        <div className="whitespace-nowrap  py-4 text-sm text-gray-600">{(element?.bidType === "preRegister") ? "Gebot erfolgt extern" : element?.bid + "€"}</div>
                                        <div className="whitespace-nowrap py-2 text-right text-sm text-gray-600">
                                            <button onClick={() => { setCurrentTender(element); setOpenContractTender(true);  }}  type="button"  className="ml-3 inline-flex items-center rounded-md ring-2 ring-indigo-700 px-3 py-2 text-sm font-semibold text-indigo-700 shadow-sm hover:bg-indigo-500 hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                                                Beauftragen
                                            </button>
                                        </div>

                                    </div>
                                ))}
                            </div>
                        </table>
                    ) : (
                        <div className={"items-center flex text-center"}>
                            <div className={" m-auto w-4/12 flex text-center"}>
                                <img src={NotFound} alt="Not Found"></img>
                            </div>
                            <div className={"text-gray-600 w-8/12 m-4"}>
                                <b>Kein Gebot vorhanden</b>
                                <p>
                                    Wir warten aktuell auf erstes Angebot. Sobald ein Angebot vorliegt, informieren wir Sie.
                                </p>
                            </div>
                        </div>
                    )}
                    <ContractTenderModal data={currentTender} />
                </div>
            </div>
        </div>
*/

}
